"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
require("./index.scss");
const react_helmet_1 = __importDefault(require("react-helmet"));
const common_1 = require("@Const/common");
const Button_1 = require("@Components/Buttons/Button");
const ModalPortal_1 = __importDefault(require("@Components/Popups/ModalPortal"));
const Sidebar_1 = require("@Components/Sidebars/Sidebar");
const AddNewUserSub_1 = __importDefault(require("@Components/AddNewUserSub"));
const MaintenanceMobileSubLinks_1 = __importDefault(require("@Components/MaintenanceMobileSubLinks"));
const contexts_1 = require("@App/contexts");
const ContentHeader_1 = __importDefault(require("@Components/ContentHeader"));
const UserPermissionsContentHeader_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderMaintenanceUserPermissions/UserPermissionsContentHeader"));
const RightsholderUserPermissionsUsersList_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderMaintenanceUserPermissions/RightsholderUserPermissionsUsersList"));
const analytics_utils_1 = require("@App/common/utils/analytics-utils");
const RightsholderMaintenanceUserPermissions = () => {
    const { rightsholderUserStore, uiStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [sidebarIsOpen, setSidebarIsOpen] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        (0, analytics_utils_1.analyticsSendPage)('rightsholder_user_permissions_profile');
        return () => {
            rightsholderUserStore.destroyRightsHolderUsers();
        };
    }, []);
    const isMobile = uiStore.isMobile;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.default, { title: 'User Permissions' }),
        react_1.default.createElement("div", { className: "rightsholder-maintenance-user-permissions-wrapper" },
            react_1.default.createElement("div", { className: 'global-container' },
                react_1.default.createElement(ContentHeader_1.default, { title: 'User Permissions', descriptionElement: react_1.default.createElement(UserPermissionsContentHeader_1.default, null) },
                    react_1.default.createElement(Button_1.Button, { onClick: () => setSidebarIsOpen(true), mainColor: true, type: 'primary', icon: common_1.ICONS.add }, "Add User")),
                isMobile && react_1.default.createElement(MaintenanceMobileSubLinks_1.default, null),
                react_1.default.createElement(RightsholderUserPermissionsUsersList_1.default, null),
                react_1.default.createElement(ModalPortal_1.default, { isOpen: sidebarIsOpen, onClose: () => setSidebarIsOpen(false) },
                    react_1.default.createElement(Sidebar_1.Sidebar, { onClose: () => setSidebarIsOpen(false) },
                        react_1.default.createElement(AddNewUserSub_1.default, null)))))));
};
exports.default = (0, mobx_react_1.observer)(RightsholderMaintenanceUserPermissions);
